/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {WinPresentationController} from "../WinPresentationController";
import {TombstoneRip} from "../../TombstoneRip";
import {TombstoneSplitSymbol} from "../../symbol/TombstoneSplitSymbol";
import {TombstoneRipSymbolState} from "../../symbol/TombstoneRipSymbolConfig";
import {gsap, TimelineLite} from "gsap";

export class DoubleScattersController extends WinPresentationController {

    constructor() {
        super("DoubleScattersController", false);
    }

    protected hasWin():boolean {
        return TombstoneRip.model.parsedGameData.convertScatterToReelSplit.some(p => p > -1);
    }

    protected async createWinAnimation():Promise<any> {
        const tl = new TimelineLite();
        TombstoneRip.model.parsedGameData.convertScatterToReelSplit.forEach((symId, reelId) => {
            if(symId > -1) {
                const reel = TombstoneRip.reels[reelId];
                const newSym = new TombstoneSplitSymbol("WRS", reelId, TombstoneRipSymbolState.NORMAL);
                newSym.showScatterFrame();
                const oldSym = reel.getSymbol(symId);
                newSym.position.set(oldSym.x, oldSym.y);
                reel.reelView.addSymbol(newSym);
                reel.reelView.addSymbol(oldSym);
                reel.reelView.allSymbols[reel.reelView.allSymbols.indexOf(oldSym)] = newSym;

                tl.add([
                    gsap.to(oldSym.scale, {duration : 0.5, x : 1.3, y : 1.3}),
                    gsap.to(oldSym, {duration : 0.5, alpha : 0})
                ], 0);
                tl.add(() => {
                    reel.reelView.removeSymbol(oldSym);
                    oldSym.onRemove();
                });
            }
        });
        tl.play();
        await Promise.resolve();
    }
}